import * as React from "react";
import { UserResource } from "client/resources";
import { FormFieldProps } from "components/form";
import { ChipIcon, MissingChip } from "components/Chips";
import MultiSelect from "./MultiSelect";
import { UserChip, userDisplayName } from "components/Chips/UserChip";
import { SelectItem } from "components/VirtualListWithKeyboard/SelectItem";
import Lookup from "../Lookup";

interface UserMultiSelectProps extends FormFieldProps<string[]> {
    items: UserResource[];
    label?: string | JSX.Element;
    error?: string;
}

interface UserResourceWithName extends UserResource {
    Name: string;
}

const UserTypedMultiSelect = MultiSelect<UserResourceWithName>();

const UserMultiSelect: React.FC<UserMultiSelectProps> = (props) => {
    const chipRenderer = (r: UserResourceWithName | SelectItem, onRequestDelete: (event: object) => void) => {
        const usersWithName = props.items.map((u) => ({ ...u, Name: u.DisplayName }));

        return (
            <Lookup
                lookupCollection={usersWithName}
                lookupId={r.Id}
                getIdFromElement={(element) => element.Id}
                render={(item) => <UserChip onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Delete ${item.Name}`} user={item} />}
                renderFallback={<MissingChip lookupId={r.Id} type={ChipIcon.Environment} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete} />}
            />
        );
    };

    const { items, ...rest } = props;
    return (
        <UserTypedMultiSelect
            items={items.map((i) => {
                const user = { ...i, ...{ Name: `${userDisplayName(i)} ${i.EmailAddress || ""}` } };
                return user;
            })}
            fieldName="users"
            renderChip={chipRenderer}
            renderItem={(i) => ({ primaryText: userDisplayName(i), secondaryText: i.EmailAddress })}
            {...rest}
        />
    );
};

export default UserMultiSelect;
